import { Popup } from 'devextreme-react';
import { BoardViewer } from '../board-viewer/BoardViewer';
import './BoardPopup.scss';

interface BoardPopupProps {
  visible: boolean;
  board: any;
  onHide: () => void;
}

export const BoardPopup = ({ visible, board, onHide }: BoardPopupProps) => {
  return (
    <Popup visible={visible} onHiding={onHide} dragEnabled={true} closeOnOutsideClick={false} showCloseButton={true} showTitle={true} title={board?.Rp_Nombre || 'Tablero de Control'} width={'90vw'} height={'90vh'} className='board-popup'>
      <BoardViewer board={board} height='calc(90vh - 100px)' showCloseButton={false} />
    </Popup>
  );
};
